var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49375 8.51062H9.50625V4.275H8.49375V8.51062ZM9 10.9069C9.1575 10.9069 9.28969 10.8534 9.39656 10.7466C9.50344 10.6397 9.55688 10.5075 9.55688 10.35C9.55688 10.1925 9.50344 10.0603 9.39656 9.95344C9.28969 9.84656 9.1575 9.79313 9 9.79313C8.8425 9.79313 8.71031 9.84656 8.60344 9.95344C8.49656 10.0603 8.44313 10.1925 8.44313 10.35C8.44313 10.5075 8.49656 10.6397 8.60344 10.7466C8.71031 10.8534 8.8425 10.9069 9 10.9069ZM2.25 15.75V3.2625C2.25 3.00375 2.35125 2.77031 2.55375 2.56219C2.75625 2.35406 2.9925 2.25 3.2625 2.25H14.7375C14.9963 2.25 15.2297 2.35406 15.4378 2.56219C15.6459 2.77031 15.75 3.00375 15.75 3.2625V12.0375C15.75 12.2963 15.6459 12.5297 15.4378 12.7378C15.2297 12.9459 14.9963 13.05 14.7375 13.05H4.95L2.25 15.75ZM3.2625 13.3031L4.52813 12.0375H14.7375V3.2625H3.2625V13.3031Z",
    fill: "#378FF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.0dcec97ec034012ea82cff199ac157cd.svg";
export { ForwardRef as ReactComponent };